<template>
    <Paper class="finance-detail">
        <div class="contents" v-loading="loading">
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
                <el-button type="primary" v-has="'07060001'" :disabled="isSaveFlag" @click="balanceSave">保存</el-button>
                <el-button type="primary" v-has="'07060002'" :disabled="isConfirmFlag" @click="balanceConfirm">确认</el-button>
                <el-button type="primary" v-has="'07060010'" :disabled="isCancelFlag" @click="cancelConfirm">取消确认</el-button>
                <el-button type="primary" v-has="'07060004'" :disabled="isSealFlag" @click="electronicSeal">电子签章</el-button>
                <el-button type="primary" v-has="'07060005'" :disabled="isSealFlag" @click="electronicSealRecall">电子签章撤回</el-button>
                <el-button type="primary" v-has="'07060006'" @click="balancePrint">打印</el-button>
                <el-button type="primary" v-has="'07060007'" @click="balanceExports">余额明细导出</el-button>
                <el-button type="primary" v-has="'07060008'" :disabled="this.balanceDetail.accountMode === 'B'" @click="viewAttachment">查看附件</el-button>
            </div>
            <div class="line"></div>
            <div class="head-content">
                <div class="sdh-serial">
                    <el-row>
                        <el-col :span="6">
                            <div class="sdh-common">对账单编号：{{balanceDetail.dealingsBillNo}}</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="sdh-common">对账单状态：{{dealingsBillStatusName}}</div>
                        </el-col>
                        <el-col :span="12">
                            <div class="sdh-common">对账单结果：{{dealingsAccountResultName}}</div>
                        </el-col>
                    </el-row>
                </div>
                <div class="sdh-balance-survey">
                    <div class="sdh-balance-survey-title">供应商往来余额余额调节表</div>
                    <el-row>
                        <el-col :span="12">
                            <div class="sdh-balance-survey-common">编制单位：{{balanceDetail.organizationCompanyName}}</div>
                        </el-col>
                        <el-col :span="12">
                            <div class="sdh-format">
                                <div class="occupies">占个坑</div>
                                <div class="sdh-balance-survey-common">截止日期：{{balanceDetail.endAccountCycleDate}}</div>
                            </div>
                        </el-col>
                    </el-row>
                    <balance-surey ref="balanceSurey" :balanceDetail="balanceDetail" :adjustmentOne="adjustmentOne"
                    :isSaveFlag="isSaveFlag" :isConfirmFlag="isConfirmFlag" :adjustmenttwo="adjustmenttwo" :isFildUplodFlag="isFildUplodFlag"
                        @getApAdjustmentTypeList="getApAdjustmentTypeList" @sureyFileUpload="fileUpload" />
                </div>
            </div>
            <files-upload ref="filesUpload" :balanceDetail="balanceDetail" @simpleUpload="simpleUpload" @templateDownload="templateDownload" />
        </div>
    </Paper>

</template>
<script>
import Paper from '@/components/core/paper/Paper';
import balanceSurey from './components/balanceSurvey.vue';
import common from '../../../common/common';
import mixin from './StatementDetailMixin';
import filesUpload from './dialog/uploadDialog.vue';
import md5 from 'js-md5';
import { dictWithUrl } from '@/components/lots/api';
import configs from '@/config/user.env';
import { validationDataChange } from '../../../utils/common';
import { getApDealingsBillList, getApDealingsAdjustmentList, saveApDealingsBill, getExportTask } from '../../../api/statement/statementApi';
const { initSessionData } = common;
const TENANT_CODE = 'annto';
const APPLICATION_NAME = 'LMS-BMS';
const requestResults = `截止会计期间,会计主体,供应商,分公司,服务平台,发票号,发票金额,发票余额,款项类别`;
const VUE_APP_ACCOUNT_CONVEY_CODE = 'dcd803cf-64fc-47c4-8562-870415d1f7ed';
export default {
    name: 'StatementDetails',
    components: { Paper, balanceSurey, filesUpload },
    mixins: [mixin],
    data() {
        return {
            loading: false,
            balanceDetail: {},
            contrastObject: {},
            adjustmentOne: {},
            adjustmenttwo: {},
            dealingsBillStatusName: '',
            dealingsAccountResultName: ''
        };
    },
    activated() {
        this.getBalanceDetails();
        this.getApAdjustmentTypeList(1);
        this.getApAdjustmentTypeList(2);
    },
    methods: {
        goLists() { this.$router.push({ path: `/bms/statement` }); },
        getBalanceDetails() { // 获取往来账单详情
            if (this.$route.query.hasOwnProperty('dealingsBillNo')) {
                this.loading = true;
                getApDealingsBillList({ dealingsBillNo: this.$route.query.dealingsBillNo }).then(res => {
                    if (res && +res.code === 0) {
                        this.loading = false;
                        this.balanceDetail = res.data.list[0];
                        const { SYS_DEALINGS_BILL_STATUS, SYS_DEALINGS_ACCOUNT_RESULT } = window.sessionStorage;
                        this.dealingsBillStatusName = SYS_DEALINGS_BILL_STATUS ?
                            JSON.parse(SYS_DEALINGS_BILL_STATUS)[this.balanceDetail.dealingsBillStatus] : this.balanceDetail.dealingsBillStatus;
                        this.dealingsAccountResultName = SYS_DEALINGS_ACCOUNT_RESULT ?
                            JSON.parse(SYS_DEALINGS_ACCOUNT_RESULT)[this.balanceDetail.dealingsAccountResult] : this.balanceDetail.dealingsAccountResult;
                        if (this.balanceDetail.accountDate) this.balanceDetail.accountDate = this.balanceDetail.accountDate.split(' ')[0];
                        this.contrastObject = Object.assign({}, this.balanceDetail);
                    }
                }).finally(() => { this.loading = false; });
            } else {
                this.loading = false;
                return false;
            }
        },
        getApAdjustmentTypeList(type) { // 调整项小计单独获取
            if (this.$route.query.hasOwnProperty('dealingsBillNo')) {
                const params = {
                    dealingsBillNo: this.$route.query.dealingsBillNo,
                    adjustmentType: type
                };
                getApDealingsAdjustmentList(params).then(res => {
                    if (res && +res.code === 0) {
                        if (type === 1) this.adjustmentOne = res.data;
                        else this.adjustmenttwo = res.data;
                    }
                }).finally(() => { });
            }
        },
        balanceSave() { // 保存
            if (!this.balanceDetail.replyApscAmt && this.balanceDetail.replyApscAmt !== 0 &&
             this.balanceDetail.replyApscAmt !== '0') return this.$message.warning('供方应付账款不能为空');
            if (!this.balanceDetail.replyOtherApDeposit && this.balanceDetail.replyOtherApDeposit !== 0 &&
             this.balanceDetail.replyOtherApDeposit !== '0') return this.$message.warning('供方其他应付款-押金不能为空');
            if (!this.balanceDetail.replyPrepaymentAmt && this.balanceDetail.replyPrepaymentAmt !== 0 &&
             this.balanceDetail.replyPrepaymentAmt !== '0') return this.$message.warning('供方预付账款不能为空');
            if (!this.balanceDetail.replyOtherArDeposit && this.balanceDetail.replyOtherArDeposit !== 0 &&
             this.balanceDetail.replyOtherArDeposit !== '0') return this.$message.warning('供方其他应收款-押金不能为空');
            this.loading = true;
            saveApDealingsBill(this.balanceDetail).then(res => {
                if (res && +res.code === 0) {
                    this.loading = false;
                    this.$message.success('保存成功');
                    this.getBalanceDetails();
                }
            }).finally(() => { this.loading = false; });
        },
        cancelConfirm() { // 取消确认后，对账单状态修改为"已发函"
            this.balanceDetail.dealingsBillStatus = this.balanceDetail.subNum1;
            saveApDealingsBill(this.balanceDetail).then(res => {
                if (res && +res.code === 0) {
                    this.loading = false;
                    this.$message.success('取消确认成功');
                    this.getBalanceDetails();
                }
            }).finally(() => { this.loading = false; });
        },
        balanceConfirm() { // 确认
            const data = {};
            data.subNum1 = this.balanceDetail.dealingsBillStatus;
            if (validationDataChange(this.balanceDetail, this.contrastObject)) return this.$message.warning('数据有改动，请先保存数据');
            if (validationDataChange(this.$refs.balanceSurey.AdjustmentArrayTwo, this.adjustmenttwo.efApDealingsAdjustmentList)) return this.$message.warning('调整项数据有改动，请先保存数据');
            // if (this.requiredCheck()) return;
            // 需要校验双方调整后余额是否相等
            if (this.$refs.balanceSurey.leftBalance !== this.$refs.balanceSurey.rightBalance && !this.balanceDetail.fileDownUrl) {
                return this.$confirm('贵司数据与我司不一致，请在对应数据下载相关依据模板，按模板填写后上传，以便我司核对', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => { }).catch(() => { });
            } else if (this.$refs.balanceSurey.leftBalance !== this.$refs.balanceSurey.rightBalance && this.balanceDetail.fileDownUrl) {
                data.dealingsBillStatus = 40;
                data.dealingsAccountResult = 40;
                data.isPushMip = 'Y';
            } else {
                data.dealingsBillStatus = 30;
                // 如果没有调整项，对账结果更新为“初始余额一致”。如果有调整项，对账结果更新为“调整后一致”
                if (this.$refs.balanceSurey.AdjustmentArrayOne.length > 0 || this.$refs.balanceSurey.AdjustmentArrayTwo.length > 0) {
                    data.dealingsAccountResult = 30;
                } else {
                    data.dealingsAccountResult = 20;
                }
            }
            if ((this.balanceDetail.dealingsBillStatus === 40 || this.balanceDetail.dealingsBillStatus === 50) && this.balanceDetail.fileDownUrl) {
                return this.$confirm('附件已上传，请确认是否更新附件内容', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: true,
                    cancelButtonText: '否',
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => { }).catch(active => {
                    if (active === 'cancel') this.sendDealingsBill(data);
                });
            } else {
                this.sendDealingsBill(data);
            }
        },
        requiredCheck() {
            const nullBalance = [];
            const anntoBalance = [];
            let tipString = '';
            let anntoTipString = '';
            let checkResult = false;
            if (+this.balanceDetail.originalApscAmt !== 0 && (!this.balanceDetail.replyApscAmt || +this.balanceDetail.replyApscAmt === 0)) {
                nullBalance.push('应收账款'); anntoBalance.push('应付账款');
            }
            if (+this.balanceDetail.originalOtherApDeposit !== 0 && (!this.balanceDetail.replyOtherApDeposit || +this.balanceDetail.replyOtherApDeposit === 0)) {
                nullBalance.push('其他应收款-押金'); anntoBalance.push('其他应付款-押金');
            }
            if (+this.balanceDetail.originalPrepaymentAmt !== 0 && (!this.balanceDetail.replyPrepaymentAmt || +this.balanceDetail.replyPrepaymentAmt === 0)) {
                nullBalance.push('预收账款'); anntoBalance.push('预付账款');
            }
            if (+this.balanceDetail.originalOtherArDeposit !== 0 && (!this.balanceDetail.replyOtherArDeposit || +this.balanceDetail.replyOtherArDeposit === 0)) {
                nullBalance.push('其他应付款-押金'); anntoBalance.push('其他应收款-押金');
            }
            if (nullBalance.length > 0) {
                checkResult = true;
                nullBalance.forEach(item => {
                    tipString += item.toString() + '、';
                });
                anntoBalance.forEach(item => {
                    anntoTipString += item.toString() + '、';
                });
                var reg = /、$/gi;
                anntoTipString = anntoTipString.replace(reg, '');
                tipString = tipString.replace(reg, '');
                this.$confirm('安得' + anntoTipString + '余额不为0，请填写本方' + tipString + '余额', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => { }).catch(() => { });
            }
            return checkResult;
        },
        sendDealingsBill(data) {
            const params = {
                handlerNameEn: this.balanceDetail.handlerNameEn,
                accountMode: this.balanceDetail.accountMode,
                dealingsBillNo: this.balanceDetail.dealingsBillNo,
                jobId: this.balanceDetail.jobId,
                ...data
            };
            this.loading = true;
            saveApDealingsBill(params).then(res => {
                if (res && +res.code === 0) {
                    this.loading = false;
                    this.$message.success('确认成功');
                    this.getBalanceDetails();
                }
            }).finally(() => { this.loading = false; });
        },
        balanceExports() { // 余额明细导出
            const data = {
                applicationCode: 'APP202009170009',
                applicationName: APPLICATION_NAME,
                dealingsBillNo: this.balanceDetail.dealingsBillNo,
                tenantCode: TENANT_CODE,
                reportCode: VUE_APP_ACCOUNT_CONVEY_CODE,
                requestResults: requestResults
            };
            this.loading = true;
            getExportTask(data).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('导出成功，请在右上角的文件信息中下载');
                }
            }).finally(() => { this.loading = false; });
        },
        balancePrint() { // 往来对账单打印
            if (this.balanceDetail.pdfDownUrl) window.open(this.balanceDetail.pdfDownUrl); else this.nonstandardPrint();
        },
        async nonstandardPrint() {
            const { data } = await dictWithUrl('SYS_LSRM_NEWPRINT');
            const billAccount = JSON.parse(data.SYS_LSRM_NEWPRINT['apDealingsBill']);
            this.cloudPrint(billAccount);
        },
        cloudPrint(options) {
            const printUrl = configs.cloudPrintUrl;
            const tenantCode = options.tenantCode;
            const mathTime = Math.floor(new Date().getTime() / 1000);
            const userCode = options.userCode;
            const printCode = options.printCode;
            const EncryptionParameters = printCode + mathTime + tenantCode + userCode + this.$route.query.dealingsBillNo;
            const token = md5(EncryptionParameters);
            const api = `${printUrl}/${printCode}/${mathTime}/${tenantCode}/${userCode}/${token}?dealingsBillNo=${this.$route.query.dealingsBillNo}`;
            var printer = window.open(api);
            return printer;
        }
    },
    mounted() {
        this.getBalanceDetails();
        this.getApAdjustmentTypeList(1);
        this.getApAdjustmentTypeList(2);
    },
    created() {
        initSessionData(['SYS_BMS_AP_PAYMENT_STAT_SUPP', 'SYS_BMS_APPLY_INVOICE_STATUS', 'SYS_SU_CONTRACT_STATUS_SUPP', 'SYS_SUPPLIER_SERVICES_SUPP',
            'SYS_BMS_AP_APPLY_STATUS_SUPP', 'BID_BUSINESS_TYPE', 'SYS_DEALINGS_BILL_STATUS', 'SYS_DEALINGS_ACCOUNT_RESULT']);
    }
};
</script>
<style lang="less">
@import "../../../styles/common.less";
@import "./StatementDetails.less";
</style>
